import React, { useState } from 'react';
import './Services.css';
import CruiseInquiryModal from './CruiseInquiryModal';

const Services = () => {
    const [isCruiseModalOpen, setIsCruiseModalOpen] = useState(false);
    const [toastMessage, setToastMessage] = useState({ text: '', type: '' });

    const showToast = (text, type) => {
        setToastMessage({ text, type });
        setTimeout(() => setToastMessage({ text: '', type: '' }), 3000);
    };

    const services = [
        {
            title: 'Domestic Tours',
            description: 'Explore the hidden gems and vibrant culture of your own homeland.',
            icon: 'fa-solid fa-map-location-dot',
            image: 'https://images.unsplash.com/photo-1587474260584-136574528ed5?q=80&w=1200&auto=format&fit=crop',
            color: '#4f46e5',
            onClick: () => window.location.href = '/packages'
        },
        {
            title: 'International Tours',
            description: 'Jet set to dream destinations across the globe with our travel plans.',
            icon: 'fa-solid fa-earth-americas',
            image: 'https://images.unsplash.com/photo-1493976040374-85c8e12f0c0e?auto=format&fit=crop&q=80&w=800',
            color: '#2563eb',
            onClick: () => window.location.href = '/packages'
        },
        {
            title: 'Flight Booking',
            description: 'Seamless booking experience for domestic and international flights.',
            icon: 'fa-solid fa-plane-up',
            image: 'https://images.unsplash.com/photo-1569154941061-e231b4725ef1?auto=format&fit=crop&q=80&w=800',
            color: '#0891b2',
            onClick: () => window.location.href = '/flights'
        },
        {
            title: 'Cruises',
            description: 'Luxury cruise experiences across stunning ocean destinations worldwide.',
            icon: 'fa-solid fa-ship',
            image: 'https://images.unsplash.com/photo-1548574505-5e239809ee19?auto=format&fit=crop&q=80&w=800',
            color: '#0284c7',
            onClick: () => setIsCruiseModalOpen(true)
        },
        {
            title: 'Visa Services',
            description: 'Hassle-free visa processing and documentation assistance.',
            icon: 'fa-solid fa-passport',
            image: 'https://images.unsplash.com/photo-1544644181-1484b3fdfc62?auto=format&fit=crop&q=80&w=800',
            color: '#059669',
            onClick: () => window.location.href = '/visa'
        },
        {
            title: 'Customized Packages',
            description: 'Tailor-made itineraries designed specifically to match your style.',
            icon: 'fa-solid fa-sliders',
            image: 'https://images.unsplash.com/photo-1501785888041-af3ef285b470?auto=format&fit=crop&q=80&w=800',
            color: '#d97706',
            onClick: () => window.location.href = '/contact'
        }
    ];

    return (
        <section className="services-section" id="services">
            <div className="services-container">
                <div className="services-header">
                    <span className="sub-heading">What We Offer</span>
                    <h2 className="main-heading">Our Premium Services</h2>
                    <p className="section-description">
                        Discover a world of possibilities with our comprehensive travel solutions.
                    </p>
                </div>

                <div className="services-grid">
                    {services.map((service, index) => (
                        <div key={index} className="service-card" style={{ backgroundImage: `url(${service.image})` }}>
                            <div className="card-overlay"></div>
                            <div className="card-content">
                                <div className="icon-badge">
                                    <i className={service.icon}></i>
                                </div>
                                <div className="text-content">
                                    <h3>{service.title}</h3>
                                    <p>{service.description}</p>
                                </div>
                                <button onClick={service.onClick} className="service-btn">
                                    Explore More <i className="fa-solid fa-arrow-right"></i>
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <CruiseInquiryModal 
                isOpen={isCruiseModalOpen} 
                onClose={() => setIsCruiseModalOpen(false)}
                showToast={showToast}
            />

            {toastMessage.text && (
                <div className={`toast-notification toast-${toastMessage.type}`}>
                    <i className={`fa-solid ${toastMessage.type === 'success' ? 'fa-check-circle' : 'fa-exclamation-circle'}`}></i>
                    {toastMessage.text}
                </div>
            )}
        </section>
    );
};

export default Services;
